import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_PARTICULAR_ENTERPRISE = 'GET_PARTICULAR_ENTERPRISE';
export const GET_PARTICULAR_ENTERPRISE_SUCCESS =
  'GET_PARTICULAR_ENTERPRISE_SUCCESS';
export const GET_PARTICULAR_ENTERPRISE_FAILURE =
  'GET_PARTICULAR_ENTERPRISE_FAILURE';

// Action Creators
export const getParticularEnterprise = () => ({
  type: GET_PARTICULAR_ENTERPRISE,
});

export const getParticularEnterpriseSuccess = (data) => ({
  type: GET_PARTICULAR_ENTERPRISE_SUCCESS,
  payload: data,
});

export const getParticularEnterpriseFailure = (error) => ({
  type: GET_PARTICULAR_ENTERPRISE_FAILURE,
  payload: error,
});

// Thunk Function
export const getParticularEnterpriseCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(getParticularEnterprise());
    try {
      console.log(data, '123');
      const response = await getMethodWithToken(
        url.particularEnterprise + data + '/'
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getParticularEnterpriseSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getParticularEnterpriseFailure(error?.message));
    }
  };
};
